module.exports = __webpack_public_path__ + "img/382-c31675.png";